module.exports = __webpack_public_path__ + "img/impresoraFiscal64.d95d0b5d.png";